<style>
.tooltip {
  opacity: 1 !important;
  background-color: rgb(0, 0, 2);
  color: white;
}
</style>

<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
      
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex s12 md9">
      	 <va-card >
           <template #title>
    {{$t('loans.myappliedloans')}}
  </template>
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>
          <va-input
          class="ma-0"
          :value="term"
          :placeholder="$t('tables.searchByName')"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
          <va-data-table
      :fields="mode ? detailedFields : fields"
      :data="filteredData"
      
      hoverable
    >
      <template slot="icon">
        <va-icon name="fa fa-list" color="secondary" />
      </template>
      <template v-slot:LoanapplicationNo="props">
        {{ props.rowData.LoanapplicationNo }}
      </template>
      <template v-slot:loanType="props">
        {{ props.rowData.loanType  }}
      </template>
      <template v-slot:appliedamount="props">
        {{ props.rowData.appliedamount | Currency  }}
      </template>
    
      <template v-slot:AmountGuarantee="props">
        <div style="text-align: right;">{{ props.rowData.AmountGuarantee | Currency }}</div>
      </template>
      <template v-slot:details="props">
        <va-button  @click="moreDetails(props.rowData.LoanapplicationNo)">
                  {{ $t('More') }}
                 
                </va-button>  
      </template>
      <template v-slot:ApprovalStatus="props">

<div  v-if="props.rowData.ApprovalStatus==='Pending' "  id="app"> 
<button v-tooltip="'Your Loan is awaiting <b>Appraisal.</b> <br /> For more Information, Please contact adminitration'" style="background-color: #d1d100; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
{{ props.rowData.ApprovalStatus}}
 </button> 

</div>
<div v-if="props.rowData.ApprovalStatus==='Rejected' " id="app">
  <button v-tooltip="'Your Loan application Has been rejected at <b>Appraisal.</b> <br /> For more Information, Please contact adminitration'"  style="background-color: red; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
  {{ props.rowData.ApprovalStatus}}</button>
  
  </div>
  
<div v-if="props.rowData.ApprovalStatus==='Approved' " id="app">

<button v-tooltip="'Your Loan has been sent for <b>Appraisal.</b> <br /> You will hear from us soon.<br /> For more Information, Please contact adminitration'" style="background-color: green; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
{{ props.rowData.ApprovalStatus}}</button>

</div>

<div v-if="props.rowData.ApprovalStatus==='Unsubmitted'" id="app">

<button v-tooltip="'Your have not submitted your loans. <br /> Click <b>MORE</b> to view details and submit.'" style="background-color: blue; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
{{ props.rowData.ApprovalStatus}} 
</button> </div>
</template>
    </va-data-table>
      	 </va-card>
      </div>
    </div>
  
  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>

import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  
  components: {
    ...spinners      
  },
  name: 'loan',
  name: 'App',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      term: null,
      loadSelect:false,
      processingError: false,
      payment_method : '',
      finalPost : '',
      details:{},
      formdata:{
        phone_no:'',
        loanType:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        ApprovalStatus:'',
        grossSalary:'',
        user: '',
        
      },
      montlyrepayment:'',
      loanType:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        ApprovalStatus:'',
        repaymentperiod:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:LoanapplicationNo',
        title: this.$t('Loan Application Number'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:loanType',
        title: this.$t('Loan Type'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:appliedamount',
        title: this.$t('Applied Amount'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:AmountGuarantee',
        title: this.$t('Amount Guarantee'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:details',
        title: this.$t('More Details'),
        width: '20%',
        sortField: 'details',
      },
      {
        name: '__slot:ApprovalStatus',
        title: this.$t('Status'),
        width: '20%',
        sortField: 'amount',
      }
    ]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.description.toLowerCase().startsWith(this.term.toLowerCase()) || item.amount.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {

     },      
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit () {

    },


    GetMyAppliedLoan () {
      this.loadSelect = true
      this.loading = true
      const self = this
      const form = {
  user:this.userData.user_id
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}ListAppliedLoans`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res.slice()

      })
      .catch(function (error) {
          console.log(error)
      })
    },

    moreDetails (LoanapplicationNo) {
      console.log(LoanapplicationNo);
      this.$router.push({name: 'loan-LoansMoreDetails', params: { loan_no:LoanapplicationNo}});
},
  },
  created () { 
    this.GetMyAppliedLoan();
   
 
  }
}
</script>